import { StyleSheet } from 'aphrodite';
import { antiFlashWhite, borderColor, brandPrimary, grayIconFill, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: 12,
		marginBottom: 16,
	},
	title: {
		fontSize: 18,
		fontWeight: 600,
		margin: 0,
		flex: 1,
	},
	backButton: {
		padding: '4px 0',
	},
	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		overflow: 'auto',
		flex: 1,
	},
	emptyState: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '48px 0',
		gap: 16,
		color: grayIconFill,
	},
	emptyStateText: {
		fontSize: 16,
		margin: 0,
	},
	card: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: 16,
		border: `1px solid ${borderColor}`,
		borderRadius: 8,
		backgroundColor: white,
	},
	cardInfo: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		flex: 1,
		minWidth: 0,
	},
	cardName: {
		fontSize: 16,
		fontWeight: 600,
		margin: 0,
		overflow: 'hidden',
		display: 'flex',
		alignItems: 'center',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	cardMeta: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontSize: 13,
		color: grayIconFill,
	},
	scopeBadge: {
		marginLeft: 5,
		display: 'inline-flex',
		alignItems: 'center',
		padding: '2px 8px',
		borderRadius: 4,
		fontSize: 12,
		fontWeight: 500,
		backgroundColor: antiFlashWhite,
		color: brandPrimary,
	},
	cardActions: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		marginLeft: 16,
		flexShrink: 0,
	},
});
